import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil } from 'lodash';
import classNames from 'classnames';
// Import UI components
import { Button } from '@geneui/components';
// Import components
import Row from './Row';

const ParentRow = (props) => {
    const {
        isChecked,
        isDisabled,
        childrenList,
        id,
        name,
        onRowClick,
        onClick,
        searchInput,
        hasInfoTooltip,
        withSelect,
        withDisabled,
        popoverPosition,
    } = props;
    const [isChildrenVisible, setIsChildrenVisible] = useState(false);

    const toggleRowChildrenClickHandler = () => {
        setIsChildrenVisible(!isChildrenVisible);
    };

    useEffect(() => {
        setIsChildrenVisible(!isNil(searchInput) && !isEmpty(searchInput));
    }, [searchInput]);

    return (
        <>
            <Button
                appearance="minimal"
                className={classNames('tween-block-drpd-arrow', { activated: isChildrenVisible })}
                icon="bc-icon-arrow-right"
                onClick={toggleRowChildrenClickHandler}
            />
            <Row
                onClick={onClick}
                name={name}
                isChecked={isChecked}
                key={`${id}_parent`}
                isDraggable={false}
                hasInfoTooltip={false}
                withSelect={withSelect}
                isDisabled={isDisabled}
                withDisabled={withDisabled}
            />
            <div className="d-a-d-child-wrapper">
                {isChildrenVisible &&
                    childrenList.map((item, index) => {
                        if (!item.isVisible) {
                            return <></>;
                        }
                        return (
                            <Row
                                key={`${item.id}_${index}`}
                                {...item}
                                onClick={onRowClick(index)}
                                isDraggable={false}
                                hasInfoTooltip={hasInfoTooltip}
                                withSelect={withSelect}
                                withDisabled={withDisabled}
                                popoverPosition={popoverPosition}
                            />
                        );
                    })}
            </div>
        </>
    );
};

ParentRow.propTypes = {
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    childrenList: PropTypes.array,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
    onRowClick: PropTypes.func,
    onClick: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    searchInput: PropTypes.string,
    hasInfoTooltip: PropTypes.bool,
    withSelect: PropTypes.bool,
    withDisabled: PropTypes.bool,
    popoverPosition: PropTypes.oneOf(['left', 'right']),
};
ParentRow.defaultProps = {
    withSelect: true,
    withDisabled: false,
    popoverPosition: 'right',
};

export default ParentRow;
